<template>
  <n-config-provider
    :locale="currentLocale.locale"
    :date-locale="currentLocale.dateLocale"
  >
    <n-message-provider>
      <n-notification-provider placement="top">
        <n-dialog-provider>
          <router-view />
        </n-dialog-provider>
      </n-notification-provider>
    </n-message-provider>
  </n-config-provider>
</template>
<script setup lang="ts">
import { ref, computed, watch } from "vue"; // ref, computed, watch 임포트
import {
  NConfigProvider,
  NMessageProvider,
  NNotificationProvider,
  NDialogProvider,
  koKR, // 한국어 로케일
  dateKoKR, // 한국어 날짜 로케일
  enUS, // 영어 로케일 (예시)
  dateEnUS, // 영어 날짜 로케일 (예시)
  // 필요한 다른 언어 로케일들도 임포트
} from "naive-ui";

const currentLanguage = ref(localStorage.getItem("userLanguage") || "ko"); // 기본값 'ko'

const naiveUiLocales = {
  ko: { locale: koKR, dateLocale: dateKoKR },
  en: { locale: enUS, dateLocale: dateEnUS },
};

const currentLocale = computed(() => {
  return (
    naiveUiLocales[currentLanguage.value as keyof typeof naiveUiLocales] ||
    naiveUiLocales.ko
  ); // 지원하지 않는 언어일 경우 기본값(한국어)
});

watch(currentLanguage, (newLang) => {
  localStorage.setItem("userLanguage", newLang);
});

function changeLanguage(lang: string) {
  currentLanguage.value = lang;
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.main_div {
  width: 100%;
  height: 100%;
}

.n-message-container {
  z-index: 9999 !important;
}

.n-notification-container {
  z-index: 9999 !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%);
}

.outer {
  position: relative;
}
.inner {
  position: absolute;
}
.content_delimiter_line {
  border: lightgrey 2px solid;
  width: 100%;
  margin-top: 5px;
  margin-bottom: 10px;
}

.success-message {
  color: green;
}

.error-message {
  color: #d8000c; /* 기존 에러 메시지 색상과 동일하게 */
}

.details-subtitle {
  font-size: 1.1em;
  color: #333;
  margin-bottom: 10px;
  padding-bottom: 5px;
  border-bottom: 1px solid #eee;
}

.action-button,
.close-button,
.cancel-button {
  margin-bottom: 20px;
  padding: 10px 18px;
  cursor: pointer;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 1em;
  transition: background-color 0.2s ease-in-out;
}

.action-button {
  background-color: #007bff;
}
.action-button:hover {
  background-color: #0056b3;
}

.close-button,
.cancel-button {
  background-color: #6c757d;
  margin-top: 10px;
}
.close-button:hover,
.cancel-button:hover {
  background-color: #545b62;
}

.loading-indicator {
  color: #555;
  padding: 15px 0;
  text-align: center;
}

.error-message {
  color: #d8000c;
  background-color: #ffd2d2;
  border: 1px solid #d8000c;
  padding: 12px;
  border-radius: 5px;
  margin-bottom: 20px;
}

.content-wrap {
  float: left;
  background-color: white;
  display: flex;
}
</style>
